const isNumeric = (input: string): boolean => input !== '' && !Number.isNaN(Number(input));

export default isNumeric;
